module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-2-a9c95f5aaecdce320ef7591861495b1b.gif";